import React, { useState } from 'react';
import { database } from '../data/database.ts';

const Contact: React.FC = () => {
  const db = database.contact;

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
      const response = await fetch("https://qorisolutions-sendmail.rugitec-corp.workers.dev/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
        setStatus("success");
      } else {
        const errorData = await response.json();
        setStatus("error");
        console.error("Error al guardar datos:", errorData);
      }
    } catch (error) {
      setStatus("error");
      console.error("Error de red:", error);
    }
  };

  return (
    <section id="contact" className="contact section">
      <div className="container" data-aos="fade" data-aos-delay="100">
        <div className="row gy-4">
          <div className="col-lg-6">
            <div className="section-title" data-aos="fade-up">
              <h2 className="section-title">{db.title}</h2>
            </div>
            <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="300">
              <p>{db.description}</p>
            </div>
          </div>
          <div className="col-lg-6">
            <form onSubmit={handleSubmit} className="email-form" data-aos="fade-up" data-aos-delay="200">
              <div className="row gy-4">
                <div className="col-md-6">
                  <input type="text" name="name" className="form-control" value={formData.name} onChange={handleChange} placeholder={db.form.name} required />
                </div>

                <div className="col-md-6 ">
                  <input type="email" className="form-control" value={formData.email} onChange={handleChange} name="email" placeholder={db.form.email} required />
                </div>

                <div className="col-md-12">
                  <input type="text" className="form-control" value={formData.subject} onChange={handleChange} name="subject" placeholder={db.form.subject} required />
                </div>

                <div className="col-md-12">
                  <textarea className="form-control" value={formData.message} onChange={handleChange} name="message" rows={6} placeholder={db.form.message} required></textarea>
                </div>

                <div className="col-md-12 text-center">
                  {/* <div className="loading">Loading</div>
                  <div className="error-message"></div>
                  <div className="sent-message">Your message has been sent. Thank you!</div> */}

                  <button type="submit">{db.form.submit}</button>
                </div>
                {status === "loading" && <p>Enviando datos...</p>}
                {status === "success" && <p>¡Datos enviados exitosamente!</p>}
                {status === "error" && <p>Ocurrió un error al enviar los datos.</p>}
              </div>
            </form>
          </div>

        </div>

      </div>

    </section>
  );
};

export default Contact;
